import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[sharedUiSvgIcon]',
})
export class SvgIconDirective {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  sharedUiSvgIcon = input<string>();

  constructor() {
    effect(() => {
      if (this.sharedUiSvgIcon()) {
        this.updateIconSize();
      }
    });
  }

  private updateIconSize(): void {
    const svgIcon = this.sharedUiSvgIcon();

    if (svgIcon) {
      const symbol = document.getElementById(
        svgIcon,
      ) as unknown as SVGSymbolElement;

      if (symbol) {
        const viewBox = symbol.getAttribute('viewBox');
        if (viewBox) {
          const [, , width, height] = viewBox.split(' ');
          this.renderer.setStyle(this.el.nativeElement, 'width', `${width}px`);
          this.renderer.setStyle(
            this.el.nativeElement,
            'height',
            `${height}px`,
          );
        }
      }
    }
  }
}
